import { Media } from "./media.interfaces";

enum PartsOrderStatus {
  ORDERED = 'ordered',
  RECEIVED = 'received',
  CANCELLED = 'cancelled',
  BACKORDERED = 'backordered'
}

interface PartsOrder {
  id?: number;
  taskId?: number | string;
  title: string;
  status?: PartsOrderStatus;
  supplier?: string;
  orderNumber?: string;
  sku?: string;
  trackingNumber?: string;
  quantity: number;
  unitCostCents?: number;
  expectedDate?: Date | string;
  receivedDate?: Date | string;
  screenshot?: Media;
  notes?: string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
}

export { PartsOrder, PartsOrderStatus };
